import { useMemo } from 'react'

import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'
import { RichText } from '@cox/core-ui8/dist/RichText'
import { useUdoContext } from '@cox/core-ui8/dist/UdoContext'

import { ReactTextProps } from './types'
import withAEM from '../../hoc/withAEM'
import { useInversionData } from '../../hooks/useInversionData'
import { getInversionTokenValues } from '../../utils/inversion-util'
import { getTokenValues } from '../../utils/rule-builder-util'

const ReactText = (props: ReactTextProps): JSX.Element => {
  const { udo } = useUdoContext()
  const { text = '', isParsed = false, tokenProperties = '' } = props

  const RichTextWithAEM = withAEM(RichText)
  //Inversion changes Start
  const inversionItems = useInversionData()
  const newItems = useMemo(() => inversionItems, [inversionItems])
  const { appData } = useAppDataContext()
  const invTokenregex = /\[\[(?!token|offer)[^\]]+\]\]/g

  const getText = () => {
    if (appData?.page?.isLocal && invTokenregex.test(text)) {
      const matches = text?.match(invTokenregex)
      let tokenReplacedString: any = text
      tokenReplacedString = matches?.reduce((acc, invToken) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return acc.replace(invToken, (match: any, token: string) => {
          return getInversionTokenValues(invToken, newItems) ?? ''
        })
      }, text)
      return tokenReplacedString
    } else {
      return text
    }
  }
  //Inversion changes End

  const value = isParsed ? text : getTokenValues(getText(), tokenProperties, udo?.localeName)
  //pass isParsed as true as it has been handed above, that way text will be treated as is.
  const modifiedProps = { ...props, localeName: udo?.localeName, text: value, isParsed: true }
  return <RichTextWithAEM {...modifiedProps} compName={'RichText'} data-rte-editelement={true} atomSpacing={true} />
}
export default ReactText
